import React, { useState, useEffect } from "react";
// import ProjectAreaTwoItem from "./ProjectAreaTwoItem";
import CertificationCard from "./CertificationCard";
import cn from "classnames";

const CertificationSection = () => {
  const project_items = [
    {
      category: "CERTIPORT | PEARSON",
      imageUrl: "/Images/Certificates/IT-Specialist_JavaScript.jpg",
      title: "JavaScript Certification",
      className: "Global",
    },
    {
      category: "ServiceNow",
      imageUrl: "/Images/Certificates/ServiceNowCSA.jpg",
      title: "CSA Certification",

      className: "Global",
    },
    {
      category: "ServiceNow",
      imageUrl: "/Images/Certificates/ServiceNowCAD.jpg",
      title: "CAD Certification",

      className: "Global",
    },
    {
      category: "REDHAT",
      imageUrl: "/Images/Certificates/RedHat.jpg",
      title: "RHCSA Certification",

      className: "Global",
    },
    {
      category: "certiport | pearson",
      imageUrl: "/Images/Certificates/HTML_certification.jpeg",
      title: "HTML & CSS Certification",

      className: "Global",
    },
    {
      category: "NPTEL",
      imageUrl: "/Images/Certificates/NPTEL_DBMS.png",
      title: "DBMS Certification",

      className: "Global",
    },
    {
      category: "certiport | pearson",
      imageUrl: "/Images/Certificates/Python_certification.jpeg",
      title: "PYTHON Certification",

      className: "Global",
    },
    {
      category: "NPTEL",
      imageUrl: "/Images/Certificates/NPTEL(Cloud).png",
      title: "Cloude Computing Certification",

      className: "Global",
    },
    {
      category: "Technical Hub",
      imageUrl: "/Images/Certificates/ProjectSpace_Completion.jpg",
      title: "Project Space Completion",
      className: "Normal",
    },
    {
      category: "Technical Hub",
      imageUrl: "/Images/Certificates/DriveReady_Completion.jpg",
      title: "Drive Ready Completion",
      className: "Normal",
    },
    {
      category: "Technical Hub",
      imageUrl: "/Images/Certificates/LateComers.jpg",
      title: "LateComers Live Project",
      className: "Normal",
    },
    {
      category: "Brain O Vision",
      imageUrl: "/Images/Certificates/Brinovision(APP).png",
      title: "Application Development",
      className: "Normal",
    },
    {
      category: "Technical Hub",
      imageUrl: "/Images/Certificates/Veda.jpg",
      title: "Veda Live Project",

      className: "Normal",
    },
    {
      category: "Technical Hub",
      imageUrl: "/Images/Certificates/Iship1.jpg",
      title: "Iship Winners",

      className: "Normal",
    },
    {
      category: "Cisco",
      imageUrl: "/Images/Certificates/JavaScriptEssential_1.png",
      title: "Javascript Essential-1",

      className: "Normal",
    },
    {
      category: "Cisco",
      imageUrl: "/Images/Certificates/JavaScriptEssential_2.png",
      title: "Javascript Essential-2",

      className: "Normal",
    },
    {
      category: "Infosys",
      imageUrl: "/Images/Certificates/Infosys(ML).png",
      title: "Machine Learning ",

      className: "Normal",
    },
    {
      category: "Brinovision",
      imageUrl: "/Images/Certificates/Brinovision(FSD).png",
      title: "Full Stack Technologies",

      className: "Normal",
    },
    {
      category: "Cisco",
      imageUrl: "/Images/Certificates/C.jpeg",
      title: "C Programming",

      className: "Normal",
    },
    {
      category: "RedHat",
      imageUrl: "/Images/Certificates/RHSA_1.png",
      title: "RedHat System Administrator",

      className: "Normal",
    },
    {
      category: "Technical Hub",
      imageUrl: "/Images/Certificates/ProjectSpace_Invitation.jpg",
      title: "Project Space Internship",
      className: "Internships",
    },
    {
      category: "Technical Hub",
      imageUrl: "/Images/Certificates/FSD_Intersnhip.jpg",
      title: "Full Stack Technlogies Internship",

      className: "Internships",
    },
    {
      category: "Technical Hub",
      imageUrl: "/Images/Certificates/DS_Internship.jpg",
      title: "Data Structures & Algorithms Internship",

      className: "Internships",
    },
    {
      category: "Cisco",
      imageUrl: "/Images/Certificates/JavaScriptEssencial-2.png",
      title: "JavaScript Essential-2",
      className: "Badges",
    },
    {
      category: "Technical Hub",
      imageUrl: "/Images/Certificates/LiveProjects.png",
      title: "Live Projects Badge",
      className: "Badges",
    },
    {
      category: "Cisco",
      imageUrl: "/Images/Certificates/PythonEssentials-2.png",
      title: "Python Essential-2",
      className: "Badges",
    },
    {
      category: "Pearson",
      imageUrl: "/Images/Certificates/ITS-JavaScript.png",
      title: "IT Specialist JavaScript",
      className: "Badges",
    },
    {
      category: "Red Hat",
      imageUrl: "/Images/Certificates/Redhat.png",
      title: "RHCSA",
      className: "Badges",
    },
    {
      category: "Pearson",
      imageUrl: "/Images/Certificates/ITS-HTML&CSS.png",
      title: "IT Specialist HTML&CSS",
      className: "Badges",
    },
    {
      category: "Cisco",
      imageUrl: "/Images/Certificates/JavaScriptEssencial-1.png",
      title: "JavaScript Essential-1",
      className: "Badges",
    },
    {
      category: "Cisco",
      imageUrl: "/Images/Certificates/PythonEssentials-1.png",
      title: "Python Essential-1",
      className: "Badges",
    },
  ];

  const filters = [
    {
      filter: "Global",
      label: "Global Certifications",
    },
    {
      filter: "Normal",
      label: "Certificates",
    },
    {
      filter: "Internships",
      label: "Interships",
    },
    {
      filter: "Badges",
      label: "Digital Badges",
    },
  ];

  const [selectedFilter, setSelectedFilter] = useState("Global");
  const [items, setItems] = useState(project_items);
  const [animationClass, setAnimationClass] = useState("");

  const handleFilterChange = (filter) => {
    setAnimationClass("fade-out");

    setTimeout(() => {
      const newItems = project_items.filter((el) =>
        filter === "*" ? true : el.className.split(" ").includes(filter)
      );
      setSelectedFilter(filter);
      setItems(filter === "*" ? project_items : newItems);
      setAnimationClass("fade-in");
    }, 300);
  };

  // Add initial animation class on component mount
  useEffect(() => {
    setAnimationClass("fade-in");
    handleFilterChange("Global");
  }, []);

  return (
    <section
      className="project-area-two pt-110 pb-90"
      style={{ backgroundColor: "#292930", paddingBottom: 0 }}
    >
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-7 col-lg-9">
            <div className="section-title title-style-two white-title mb-60 text-center animate-up">
              <span className="sub-title">Professional Certifications</span>
              <h2 style={{ color: "white" }}>
                Skills Validated by Industry Certifications
              </h2>
              <p style={{ width: "100%" }}>
                My technical expertise has been validated through these
                certifications, demonstrating proficiency in modern development
                frameworks, data structures, and AI/ML technologies.
              </p>
            </div>
          </div>
        </div>

        <div className="project-item-wrap">
          <div className="row">
            <div className="col-lg-12">
              <div className="project-menu-nav animate-up delay-2">
                {filters.map((x, index) => (
                  <button
                    key={index}
                    className={`${
                      x.filter === selectedFilter ? "active" : ""
                    } animate-button`}
                    data-filter={x.filter}
                    onClick={() => handleFilterChange(x.filter)}
                  >
                    {x.label}
                  </button>
                ))}
              </div>
            </div>
          </div>

          <div className={`row project-active-two ${animationClass}`}>
            {items.map((x, index) => (
              <div
                key={index}
                className={cn(
                  "col-lg-4 col-md-6 grid-item grid-sizer wow fadeInUp",
                  x.className
                )}
                data-wow-delay={`0.${index * 2}s`}
              >
                <CertificationCard item={x} />
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* Add this CSS directly in the component */}
      <style jsx>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes fadeOut {
          from {
            opacity: 1;
            transform: translateY(0);
          }
          to {
            opacity: 0;
            transform: translateY(-20px);
          }
        }

        @keyframes buttonHover {
          0% {
            transform: scale(1);
          }
          50% {
            transform: scale(1.05);
          }
          100% {
            transform: scale(1);
          }
        }

        .animate-up {
          animation: fadeIn 0.6s ease-out forwards;
        }

        .delay-2 {
          animation-delay: 0.3s;
        }

        .fade-in {
          animation: fadeIn 0.5s ease-out forwards;
        }

        .fade-out {
          animation: fadeOut 0.3s ease-out forwards;
        }

        .animate-button {
          transition: all 0.3s ease;
        }

        .animate-button:hover {
          animation: buttonHover 0.3s ease-in-out;
        }
      `}</style>
    </section>
  );
};

export default CertificationSection;
